module.exports = __webpack_public_path__ + "static/media/splash.2a225341.mp3";